export default "__VITE_ASSET__a3caf387__"